import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
const Contactez = () => {
  return (
    <ContactWrapper>
      <Link to="/services">
        <motion.button
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 3 }}
          viewport={{ once: true }}
        >
          Services
        </motion.button>
      </Link>
      <Link to="/contact">
        <motion.button
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 3 }}
          viewport={{ once: true }}
        >
          Contact
        </motion.button>
      </Link>
    </ContactWrapper>
  );
};

export default Contactez;

const ContactWrapper = styled.div`
  flex: 1;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: none;
  color: white;
  @media (max-width: 1124px) {
    flex-direction: column;
  }
`;
